

import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Card, CardActions, CardMedia, Grid, Typography } from "@mui/material"
import { useValidarRoles } from "../../../hooks";
const baseUrl = process.env.REACT_APP_API_URL;




export const CardProductoCompra = ({ producto }) => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { permitirXRol } = useValidarRoles();
    const isNotCliente = permitirXRol('SUPERADMIN','ADMINISTRADOR','DISENIADOR','PRODUCCION','DISTRIBUIDOR','PUBLICISTA','EMPRESA','MARKETING');
    const isAdmin = permitirXRol('SUPERADMIN', 'ADMINISTRADOR');



    const handleNavegarVenta = (prodid) => {
        // dispatch( terminadoActivoDelete() );
        const path = isNotCliente
        ? `/super/detproventa/${id}/${prodid}`
        : `/detproventa/${id}/${prodid}`
        navigate(path);
    }


    return (
        <Grid item key={producto.id} xs={12} sm={6} md={4} lg={3}> 
            <Card sx={{ height:'100%', display:'flex', flexDirection:'column', borderRadius:'16px', overflow:'hidden', 
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border:'1px solid', borderColor:'secondary.main',
            }}> 
                <Box sx={{ position:'relative', overflow:'hidden' }}>
                    <CardMedia sx={{ height:230, transition:'transform 0.3s ease-in-out', 
                        '&:hover': {transform:'scale(1.05)'} }} 
                        image={`${baseUrl}/uploads/productos/${producto.img}`} 
                        title={producto.nombre} 
                    />
                    <Box sx={{ position:'absolute', top:0, left:0, right:0, bottom:0, pointerEvents:'none',
                        background: 'linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7))',
                    }}/>
                    <Typography variant="h5" sx={{ position:'absolute', bottom:16, left:16, right:16, 
                        textAlign:'center', fontWeight:600, color:'#ffffff', letterSpacing:'-0.3px', zIndex:100
                    }}> 
                        {producto.nombre} 
                    </Typography>
                </Box> 

                <CardActions sx={{ display:'flex', flexDirection:'column', gap:1.5, p:3, mt:1 }}> 
                    <Button fullWidth variant="contained"  color="primary"
                        sx={{ borderRadius:'10px', textTransform:'none', fontWeight:600, px:3, py:0.7 }}
                        onClick={() => handleNavegarVenta(producto.id)} 
                    > 
                        Ver Detalles 
                    </Button> 

                    {(isAdmin) && 
                        <Button fullWidth variant="outlined" color="secondary"
                            sx={{ borderRadius:'10px', textTransform:'none', fontWeight:600, px:3, py:0.7, borderWidth:'2px' }}
                            onClick={() => navigate(`/super/actualizar-prod/${producto.id}`)}
                        > 
                            Editar Producto 
                        </Button> 
                    } 
                </CardActions> 
            </Card> 
        </Grid> 
    )
}
